import { motion } from "framer-motion";
import { Phone, Clock } from "lucide-react";

export default function Availability() {
  return (
    <section
      data-testid="availability-section"
      className="relative overflow-hidden bg-[#0052FF] py-20 sm:py-28"
    >
      <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full border-[40px] border-white/10" />
      <div className="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full border-[32px] border-black/10" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 48 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="grid items-center gap-10 md:grid-cols-12"
        >
          <div className="md:col-span-8">
            <p className="mb-5 inline-flex items-center gap-2 bg-black px-3 py-1.5 font-tech text-[11px] uppercase tracking-[0.25em] text-white sm:text-xs">
              <Clock className="h-3.5 w-3.5" />
              On call when needed
            </p>
            <h2 className="font-display text-5xl font-extrabold uppercase leading-[0.9] tracking-tight text-white sm:text-7xl">
              When needed,
              <br />
              we'll be there.
            </h2>
            <p className="relative z-10 mt-6 max-w-lg text-base font-medium text-black sm:text-lg">
              Concrete doesn't wait and neither do we. One call and the pump is on
              its way — early mornings, weekends, that pour that can't slip.
            </p>
          </div>

          <div className="md:col-span-4 md:justify-self-end">
            <div className="mx-auto w-full max-w-[280px] border-2 border-black bg-[#0A0C10] p-6 text-center">
              <p className="mb-1 flex items-center justify-center gap-2 font-tech text-[11px] uppercase tracking-[0.25em] text-[#7EB0FF]">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#0052FF] opacity-75" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-[#0052FF]" />
                </span>
                Crews on call now
              </p>
              <div className="mt-4 flex flex-col gap-3">
                <a
                  href="tel:0450454453"
                  data-testid="availability-call-button"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap bg-[#0052FF] px-5 py-3.5 font-display text-lg font-bold uppercase tracking-wider text-white transition-all duration-300 hover:bg-[#2E74FF] hover:shadow-[0_0_36px_rgba(0,82,255,0.6)]"
                >
                  <Phone className="h-6 w-6" />
                  Andrew — 0450 454 453
                </a>
                <a
                  href="tel:0474422539"
                  data-testid="availability-call-eli-button"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap border-2 border-[#0052FF] px-5 py-3.5 font-display text-lg font-bold uppercase tracking-wider text-white transition-all duration-300 hover:bg-[#0052FF] hover:shadow-[0_0_36px_rgba(0,82,255,0.6)]"
                >
                  <Phone className="h-6 w-6" />
                  Eli — 0474 422 539
                </a>
              </div>
              <p className="mt-4 font-tech text-[11px] uppercase tracking-[0.2em] text-slate-400">
                Straight to the operators — no call centres
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}